import { render } from "./SwatchList.vue?vue&type=template&id=764328c5&scoped=true"
import script from "./SwatchList.vue?vue&type=script&lang=js"
export * from "./SwatchList.vue?vue&type=script&lang=js"

import "./SwatchList.vue?vue&type=style&index=0&id=764328c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764328c5"]])

export default __exports__